export default (basketItem) => {
  const noExternalMasterProductId = () => {
    if (window.start?.settings?.default_to_thg_product_id_for_gtm) {
      return basketItem.productId || basketItem.externalProductId;
    }
    return basketItem.externalProductId || basketItem.productId;
  };
  
  if (window.start?.settings?.should_use_external_master_product_id) {
    return basketItem.externalMasterProductId || noExternalMasterProductId();
  }
  
  return noExternalMasterProductId();
};
